<div class="byhoursFiltetCont">
  <ng-container *ngIf="!isResults">
    <app-ds-typography
      [size]="fontSize.XXS"
      [fontFamily]="fontFamily.Regular"
      [color]="fontColor.Primary"
      [text]="'SEARCH_MODULE.BYHOURS_SELECT_HOURS' | transloco">
    </app-ds-typography>
  </ng-container>
  <div class="byhoursFiltetCont__selection">
    <div *ngFor="let hour of hours; trackBy: trackById" class="byhoursFiltetCont__block">
      <app-ds-floating-filter
        [type]="floatingFilterType"
        [size]="floatingFilterSize"
        [image]="hoursImageUrl(hour)"
        [label]="hour + 'h'"
        (clickEvent)="hourSelected(hour)">
      </app-ds-floating-filter>
    </div>
  </div>
</div>
